import { __extends } from "tslib";
import * as React from 'react';
import { consumeTheme } from '../../utils/theme';
var Option = (function (_super) {
    __extends(Option, _super);
    function Option() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.themedRender = function (classNames) {
            return null;
        };
        return _this;
    }
    Option.prototype.render = function () {
        return consumeTheme(this.themedRender);
    };
    return Option;
}(React.Component));
export default Option;
Option.defaultProps = {
    disabled: false,
};
